module.exports = __webpack_public_path__ + "static/media/mountains-world-small.60c75723.jpg";